/**
 * Marks aria-hidden / cloned slick slides as `inert` so focusable children
 * inside them cannot receive keyboard focus (Agent Accessibility / axe).
 * Visible slides have `inert` removed.
 * @param {ParentNode|null|undefined} root - Carousel container element.
 * @returns {void}
 */
export function syncSlickSlideInert(root) {
  if (!root || typeof root.querySelectorAll !== "function") {
    return;
  }

  root.querySelectorAll(".slick-slide").forEach((slide) => {
    const isHidden = slide.getAttribute("aria-hidden") === "true" || slide.classList.contains("slick-cloned");

    if (isHidden) {
      slide.setAttribute("inert", "");
    } else {
      slide.removeAttribute("inert");
    }
  });
}
